export const ACCOUNT_FEATURE_ALLOW_LIVE_MEETINGS = 'allowLiveMeetings';
export const ACCOUNT_FEATURE_PAST_MEETINGS_ENABLED = 'isPastMeetingsEnabled';
export const ACCOUNT_FEATURE_MAX_MEETINGS = 'maxMeetings';
export const ACCOUNT_FEATURE_PURCHASED_USERS = 'purchasedUsers';
export const ACCOUNT_FEATURE_ALLOW_DEVICE_PAIRING = 'allowDevicePairing';
export const ACCOUNT_FEATURE_CHAT_ENABLED = 'isChatEnabled';
export const ACCOUNT_FEATURE_OTHERWAYS_ENABLED = 'isOtherWaysToCallEnabled';
export const ACCOUNT_FEATURE_DEVICE_SETTINGS_ENABLED = 'isDeviceSettingsEnabled';
export const ACCOUNT_FEATURE_SSO = 'sso';
export const ACCOUNT_FEATURE_STREAMING = 'streaming';
